import * as React from 'react';
export const IcLink = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.29 10.29a.996.996 0 000 1.41c.87.87 1 2.16.3 2.87l-3.07 3.07c-.32.33-.78.48-1.3.45-.57-.04-1.12-.3-1.56-.75-.44-.44-.71-1-.74-1.56-.04-.52.12-.98.45-1.3l1.28-1.28a.996.996 0 10-1.41-1.41l-1.28 1.28c-.74.74-1.1 1.75-1.03 2.85.07 1.05.54 2.06 1.33 2.84a4.52 4.52 0 002.84 1.33h.29c.99 0 1.89-.36 2.57-1.04l3.07-3.07c1.49-1.49 1.35-4.04-.3-5.7a.996.996 0 00-1.41 0l-.03.01zm6.47-5.05a4.52 4.52 0 00-2.84-1.33c-1.1-.08-2.12.29-2.85 1.03L10 8.01c-.74.74-1.1 1.75-1.03 2.85.07 1.05.54 2.06 1.33 2.84.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41c-.44-.44-.71-1-.74-1.56-.04-.52.12-.98.45-1.3l3.07-3.07c.33-.33.79-.48 1.3-.45.57.04 1.12.3 1.56.75.44.44.71 1 .74 1.56.04.52-.12.98-.45 1.3l-1.28 1.28a.996.996 0 101.41 1.41l1.28-1.28c.74-.74 1.1-1.75 1.03-2.85-.07-1.05-.54-2.06-1.33-2.84z'
      fill='currentColor'
    />
  </svg>
);
